const ALL_TYPE_CATEGORIES = new Set(['CBD', 'ACCESSORIES', 'APPAREL']);
const ALL_SUFFIX = '_ALL';
const MEDICAL = 'medical';
const MEDICAL_SUFFIX = '_MEDICAL';
const RECREATIONAL_SUFFIX = '_ADULT';

const getSkuSuffix = (category, menu) => {
  if (
    typeof category === 'string' &&
    ALL_TYPE_CATEGORIES.has(category.toUpperCase())
  ) {
    return ALL_SUFFIX;
  }

  if (typeof menu === 'string' && menu.toLowerCase() === MEDICAL) {
    return MEDICAL_SUFFIX;
  }

  return RECREATIONAL_SUFFIX;
};

export default getSkuSuffix;
